import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=3ca33f90&scoped=true&"
import script from "./Guidance.vue?vue&type=script&lang=js&"
export * from "./Guidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca33f90",
  null
  
)

export default component.exports